import {
  SplitVariableIterator,
  useDashboardFocus,
  useIsSplitModeEnabled,
  useSplitVariableState,
} from '@/dashboards/context';
import { PanelOptions } from '../Panel';
import { GridLayout } from './GridLayout';

export function SplitGridLayout(props: {
  panelGroupId: number;
  panelGroupIndex: number;
  panelOptions: PanelOptions | undefined;
  omitTitle?: boolean;
}) {
  const { panelGroupId } = props;

  // Works with pastePanel slice to determine which group should be pasted into.
  const { focusedPanelGroupId, setFocusedPanelGroupId, isFocusEnabled } = useDashboardFocus();

  // Dynamic panel groups using split_by variable.
  // Do not need to support focused state since you would not paste into a dynamic group.
  const isSplitModeEnabled = useIsSplitModeEnabled();
  const { splitVariableName } = useSplitVariableState();
  if (isSplitModeEnabled && splitVariableName) {
    return (
      <SplitVariableIterator
        variableName={splitVariableName}
        renderItem={(variableName) => {
          return <GridLayout key={variableName} {...props} />;
        }}
      />
    );
  }

  // Only update focus state when enablePastePanelDefinition is true in dashboard config.
  if (isFocusEnabled) {
    return (
      <div
        onFocus={() => {
          if (focusedPanelGroupId !== panelGroupId) {
            setFocusedPanelGroupId(panelGroupId);
          }
        }}
        onBlur={() => {
          if (focusedPanelGroupId === panelGroupId) {
            setFocusedPanelGroupId(undefined);
          }
        }}
      >
        <GridLayout {...props} />
      </div>
    );
  }

  // Fallback to showing normal layout w/o focus handlers or repeat variable state injected.
  return <GridLayout {...props} />;
}
